/**
 * Custom hooks per Agents
 */
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";
import type { Agent, AgentResponse } from "@/types/workflow";

const AGENTS_QUERY_KEYS = {
    all: ["agents"] as const,
    lists: () => [...AGENTS_QUERY_KEYS.all, "list"] as const,
    list: () => [...AGENTS_QUERY_KEYS.lists()] as const,
};

/**
 * Hook per lista agenti
 */
export function useAgents() {
    return useQuery({
        queryKey: AGENTS_QUERY_KEYS.list(),
        queryFn: async (): Promise<Agent[]> => {
            // L'API restituisce direttamente un array, non un oggetto con { success, data }
            const response = await apiGet<AgentResponse[]>("/agents");
            // Mappa agent_id a id e include tutte le informazioni rilevanti
            return (response || []).map((agent: AgentResponse) => ({
                id: agent.agent_id,
                name: agent.name,
                description: agent.description,
                agent_type: agent.agent_type || agent.agent_metadata?.agent_type,
                specialization: agent.agent_metadata?.specialization,
                status: agent.status,
                is_default: agent.is_default || agent.agent_metadata?.is_default,
                tools: agent.agent_metadata?.tools,
                rag_sources: agent.agent_metadata?.rag_sources,
            }));
        },
    });
}
